<template>

  <a-modal
    title="添加来源"
    :width="500"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form >
      <a-form-item
        label="来源名称"
        :labelCol="{lg: {span: 6}, sm: {span: 6}}"
        :wrapperCol="{lg: {span: 14}, sm: {span: 14} }"
      >
        <a-input
          style="margin-left:6px"
          placeholder="请输入来源名称"
          v-model="value"
          v-focus="focus"
          @keyup.enter="handleOk" />
      </a-form-item>
    </a-form>
  </a-modal>

</template>

<script>
import { addHospital, editHospital } from '@/api/hospital'

export default {
  name: 'AddHospitalModal',
  data () {
    return {
      focus: true,
      visible: false,
      isEdit: false,
      hospitalId: '',
      value: '',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }

    }
  },
  created () {},
  methods: {
    add () {
      this.visible = true
      this.value = ''
    },
    edit (record) {
      this.value = record.source_name
      this.hospitalId = record.source_id
      this.visible = true
      this.isEdit = true
    },
    close () {
      this.$emit('close')
      this.value = ''
      this.visible = false
    },
    handleOk () {
      const _this = this
      const projectId = this.$store.getters.projectId
      const hospital = this.value
      if (this.isEdit) {
        editHospital(this.hospitalId, hospital).then(() => {
          _this.$message.success('修改成功')
          _this.$emit('ok')
        }).catch(() => {
          _this.$message.error('修改失败')
        }).finally(() => {
          _this.close()
        })
      } else {
        addHospital(projectId, hospital).then(() => {
          _this.$message.success('添加成功')
          _this.$emit('ok')
        }).catch(() => {
          _this.$message.error('添加失败')
        }).finally(() => {
          _this.close()
        })
      }
    },
    handleCancel () {
      this.close()
    }
  }
}
</script>
